import { updatedDiff } from '@helpers/data';

import { PaymentsSetPaymentSystemDistributionPercentReducer } from './types';

export const paymentsSetPaymentSystemDistributionPercentReducer: PaymentsSetPaymentSystemDistributionPercentReducer =
  (state, action) => {
    const { aggregatorId, paymentSystemId, distributionPercent } =
      action.payload;

    if (
      !paymentSystemId ||
      !state.paymentsDistributionSettingsProcessedItems ||
      !state.paymentsDistributionSettingsItems
    ) {
      return state;
    }

    const processed = {
      ...state.paymentsDistributionSettingsProcessedItems,
      [aggregatorId]: {
        ...state.paymentsDistributionSettingsProcessedItems[aggregatorId],
        paymentSystems: {
          ...(state.paymentsDistributionSettingsProcessedItems[aggregatorId]
            ?.paymentSystems ?? {}),
          [paymentSystemId]: {
            ...(state.paymentsDistributionSettingsProcessedItems[aggregatorId]
              ?.paymentSystems
              ? state.paymentsDistributionSettingsProcessedItems[aggregatorId]
                  ?.paymentSystems[paymentSystemId]
              : {}),
            distributionPercent,
          },
        },
      },
    };

    const changes = updatedDiff(
      state.paymentsDistributionSettingsItems,
      processed
    );

    return {
      ...state,
      paymentsDistributionSettingsProcessedItems: {
        ...changes,
      },
    };
  };
